import walletCampusPopup from './wallet/popup';
import registrationFeePopup from './registration-fee/popup';

export default [...walletCampusPopup, ...registrationFeePopup];
